import { useTranslation } from "react-i18next";

export default function CTABanner() {
  const { t } = useTranslation("inbraakschade-reparatie");

  return (
    <section className="bg-brand-yellow py-16 md:py-24 w-full text-center">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-8 md:mb-10">
          {t("ctaBanner.h2")}
        </h2>
        <a
          href="tel:+31638272035"
          className="inline-flex items-center gap-2 font-geist font-bold text-sm md:text-base bg-brand-text text-white px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-brand-blue transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
          06 38 27 20 35
        </a>
        <p className="font-geist text-sm text-brand-text/70 mt-4">
          Kantoor: <a href="tel:+31407987470" className="underline hover:text-brand-text">040 798 7470</a>
          <span className="block mt-1 text-brand-text/50 text-xs">06-nummer 24/7 bereikbaar voor spoed</span>
        </p>
      </div>
    </section>
  );
}